document.addEventListener("DOMContentLoaded", function() {
    const faqNavDoms = document.querySelectorAll('.faq-nav li');

    if (faqNavDoms.length > 0) {
        faqNavDoms.forEach((item, index) => {
            item.addEventListener('click', function() {

                const targetId = this.getAttribute('data-nav-id');
                if (!targetId) return;

                const targetElement = document.querySelector(`[data-faq-target-id=${targetId}]`);
                if (targetElement) {
                    targetElement.scrollIntoView({ behavior: 'smooth' });
                }
            });
        });
    }

    const faqSearchInput = document.querySelector('.faq-banner-content input');
    let searchedQuestionsData = [];
    if (!faqSearchInput) return;

    faqSearchInput.addEventListener('focus', function() {
        document.querySelector('.faq-search-bar').classList.add('input-focused');
    });

    document.addEventListener('click', function(event) {
        if (!event.target.closest('.faq-search-bar')) {
            document.querySelector('.faq-search-bar').classList.remove('input-focused');
        }
    });

    faqSearchInput.addEventListener('input', function() {
        searchedQuestionsData = [];
        const query = this.value.toLowerCase();
        const faqItems = document.querySelectorAll('.collapsible-content .accordion__title span');

        faqItems.forEach(item => {
            const question = item.textContent.toLowerCase();
            const answer = item.closest('details').querySelector('.accordion__content').textContent.toLowerCase();

            if (question.includes(query) || answer.includes(query)) {
                searchedQuestionsData.push(item);
            }
        });
        renderSearchedQuestions();
    });

    function renderSearchedQuestions() {
        const searchResultsDom = document.querySelector('.search-results .results-list');
        searchResultsDom.innerHTML = '';

        searchedQuestionsData.forEach(item => {
            const listItem = document.createElement('li');
            listItem.textContent = item.textContent;
            searchResultsDom.appendChild(listItem);
        });

        bindSearchedQuestionsClick();
    }

    function bindSearchedQuestionsClick() {
        const searchResultsDom = document.querySelector('.search-results .results-list');
        searchResultsDom.addEventListener('click', function(event) {
            // hide search results
            document.querySelector('.faq-search-bar').classList.remove('input-focused');
            
            if (event.target.tagName.toLowerCase() === 'li') {
                const questionText = event.target.textContent;
                const faqItems = document.querySelectorAll('.collapsible-content .accordion__title');

                faqItems.forEach(item => {
                    if (item.querySelector('span').textContent === questionText) {
                        // open the accordion if it's not already open
                        const accordionContent = item.closest('details');
                        if (accordionContent && !accordionContent.hasAttribute('open')) {
                            accordionContent.setAttribute('open', 'true');
                        }
                        item.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                });
            }
        });
    }

});